"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuerDeclarationSubformCalculationMethod = exports.EuerDeclarationSubformType = void 0;
var EuerDeclarationSubformType;
(function (EuerDeclarationSubformType) {
    EuerDeclarationSubformType["BUSINESS_ASSETS"] = "BUSINESS_ASSETS";
    EuerDeclarationSubformType["CAR_USAGE"] = "CAR_USAGE";
    EuerDeclarationSubformType["OFFICE_USAGE"] = "OFFICE_USAGE";
    EuerDeclarationSubformType["TRAVEL_EXPENSES"] = "TRAVEL_EXPENSES";
})(EuerDeclarationSubformType || (exports.EuerDeclarationSubformType = EuerDeclarationSubformType = {}));
var EuerDeclarationSubformCalculationMethod;
(function (EuerDeclarationSubformCalculationMethod) {
    EuerDeclarationSubformCalculationMethod["BUSINESS_ASSETS_DEFAULT"] = "BUSINESS_ASSETS_DEFAULT";
    EuerDeclarationSubformCalculationMethod["CAR_USAGE_1_PCT_METHOD"] = "CAR_USAGE_1_PCT_METHOD";
    EuerDeclarationSubformCalculationMethod["CAR_USAGE_DRIVERS_LOG"] = "CAR_USAGE_DRIVERS_LOG";
    EuerDeclarationSubformCalculationMethod["OFFICE_USAGE_FULL_COST"] = "OFFICE_USAGE_FULL_COST";
    EuerDeclarationSubformCalculationMethod["OFFICE_USAGE_UP_TO_1250_EUR"] = "OFFICE_USAGE_UP_TO_1250_EUR";
    EuerDeclarationSubformCalculationMethod["OFFICE_USAGE_FLAT_RATE_5_EUR"] = "OFFICE_USAGE_FLAT_RATE_5_EUR";
    EuerDeclarationSubformCalculationMethod["TRAVEL_EXPENSES_DEFAULT"] = "TRAVEL_EXPENSES_DEFAULT";
})(EuerDeclarationSubformCalculationMethod || (exports.EuerDeclarationSubformCalculationMethod = EuerDeclarationSubformCalculationMethod = {}));
//# sourceMappingURL=enums.js.map